import { createStyles } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    const spacing = theme.spacing(3);
    return createStyles({
        pane: {
            display: 'flex',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: spacing,
        },
        wrapper: {
            display: 'flex',
            position: 'relative',
            flexGrow: 1,
            flexDirection: 'column',
        },
        plusIconButton: {
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
        formPane: {
            display: 'flex',
            position: 'absolute',
            minHeight: '100%',
            top: 0,
            right: 0,
            left: 0,
        },
        formWrapper: {
            padding: theme.spacing(3),
            '& .MuiTextField-root': {
                margin: `${theme.spacing(1)}px 0`,
            },
        },
    });
});
